import Backbone from 'backbone';

const pubSub = Object.assign({}, Backbone.Events);
export default pubSub;